import { useRequest } from 'ahooks'
import { AutoComplete, SelectProps, Spin } from 'antd'
import { uniqBy } from 'lodash'
import React from 'react'

export const WorkResourceCustomSearch = (
  props: SelectProps & {
    defaultOptions: {
      value: string
      label: string
      id: string
    }[]
    projectWorkResourceSelfId?: string
  }
) => {
  const { onSearch, defaultOptions, projectWorkResourceSelfId, ...restProps } = props
  const { data, loading, run } = useRequest<{ selfId: string; name: string }[]>(
    (data) => ({
      url: `/api/work-resource/getSubProjectsByNameSearch?${new URLSearchParams({
        ...data,
      })}`,
      method: 'get',
    }),
    {
      manual: true,
    }
  )

  const options = uniqBy(
    (data || [])
      .map((d) => {
        return {
          value: d.name,
          label: d.name,
          id: d.selfId,
        }
      })
      .concat(defaultOptions),
    'id'
  )

  return (
    <AutoComplete
      style={{ width: '100%' }}
      allowClear
      showSearch
      dropdownMatchSelectWidth={false}
      notFoundContent={loading ? <Spin /> : null}
      options={options}
      filterOption={false}
      onSearch={(search) => {
        onSearch?.(search)
        run({ search, projectWorkResourceSelfId })
      }}
      {...restProps}
    />
  )
}
